import LocationPicker from './location-picker'

export type { LocationPickerProps } from './location-picker'

export default LocationPicker
